export default "__VITE_ASSET__CPv2LG8M__"